import { Link } from "react-router-dom";
import { Phone } from "lucide-react";

export default function Hero() {
  return (
    <section className="relative overflow-hidden bg-background">
      <div className="relative min-h-[270px] md:min-h-[600px] lg:min-h-[640px]">
        {/* Background image — mobile hero is short so the wide photo zooms out and BOTH kids' faces fit (smaller);
            desktop shows the full-bleed family frame. */}
        <img
          src="/images/hero-family.jpg"
          alt="A family relaxing at home in a comfortable, well-conditioned living room"
          className="absolute inset-0 h-full w-full object-cover object-[90%_center] md:object-center"
          loading="eager"
        />

        {/* Dark scrim — heavier on the left where the text sits, fades out over the kids */}
        <div className="absolute inset-0 bg-gradient-to-r from-ink/85 via-ink/55 to-ink/0" />
        {/* Soft top-to-bottom darkening to deepen contrast under the headline */}
        <div className="absolute inset-0 bg-gradient-to-b from-ink/30 via-transparent to-transparent" />

        {/* Text content overlay */}
        <div className="container relative flex min-h-[270px] items-center md:min-h-[600px] lg:min-h-[640px]">
          <div className="max-w-2xl py-3 md:py-16">
            <h1 className="mb-2 text-2xl font-bold leading-[1.05] tracking-tight text-white [text-shadow:_0_2px_16px_rgb(0_0_0_/_45%)] md:mb-5 md:text-5xl lg:text-6xl">
              For warm, dry, healthy homes.
            </h1>
            <p className="mb-2.5 max-w-xl text-xs text-white/95 [text-shadow:_0_1px_8px_rgb(0_0_0_/_55%)] md:mb-6 md:text-lg">
              Mangawhai's certified heat pump, air conditioning, refrigeration & home ventilation specialists.
            </p>
            <div className="mb-2.5 flex flex-wrap items-center gap-1.5 md:mb-6 md:gap-2">
              <span className="inline-flex items-center gap-2 rounded-full bg-white/95 px-2.5 py-0.5 text-xs font-semibold uppercase tracking-wide text-brand-700 shadow-md backdrop-blur md:px-4 md:py-1.5 md:text-base">
                Mangawhai <span aria-hidden className="text-brand-300">·</span> <span className="font-extrabold">20+ YEARS</span>
              </span>
              <span className="inline-flex items-center rounded-full bg-white/95 px-2.5 py-0.5 text-xs font-semibold uppercase tracking-wide text-brand-700 shadow-md backdrop-blur md:px-4 md:py-1.5 md:text-base">
                Certified Panasonic Installer
              </span>
            </div>
            <div className="flex flex-wrap gap-2">
              <Link
                to="/free-quote"
                className="inline-flex h-9 items-center justify-center rounded-md bg-brand px-5 text-sm font-semibold text-white shadow-lg transition-colors hover:bg-brand-600 md:h-12 md:px-6 md:text-base"
              >
                Get a Free Quote
              </Link>
              <a
                href="tel:0272980080"
                className="inline-flex h-9 cursor-pointer items-center justify-center gap-2 rounded-md bg-white/95 px-5 text-sm font-semibold text-ink shadow-lg backdrop-blur transition-colors hover:bg-white md:h-12 md:px-6 md:text-base"
              >
                <Phone className="h-4 w-4" /> Call 027 298 0080
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
